export default {"src":"/_next/static/media/email-icon.02005e3e.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};